import React from 'react';
import { DialogBackdrop } from '../../../../components/ui/dialog-backdrop';
import styles from './template-dialog-helpers.module.css';

interface TemplateDialogShellProps {
  onClose: () => void;
  children: React.ReactNode;
}

export const TemplateDialogShell: React.FC<TemplateDialogShellProps> = ({ onClose, children }) => (
  <div className={styles.dialog} onClick={e => e.stopPropagation()}>
    <DialogBackdrop onClose={onClose} />
    {children}
  </div>
);
